import { GridArgs } from "../../records/grids/gridArgs";

export function machineConfigurationCellClass(
  systemDate: Date,
  currentConfigurationField: string,
  machineConfigurationDateField: string
) {
  return (args: GridArgs) =>
    args.data[currentConfigurationField]
      ? ["currentConfiguration"]
      : args.data[machineConfigurationDateField] > systemDate
      ? ["pendingConfiguration"]
      : [];
}
